import { forwardRef } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const glassPanelStyles = tv({
	base: "backdrop-glass-regular flex flex-col rounded-2xl bg-alpha-40",
	variants: {
		elevation: {
			md: "shadow-glass-md",
			lg: "shadow-glass-lg",
		},
	},
	defaultVariants: {
		elevation: "md",
	},
});

export interface GlassPanelProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof glassPanelStyles> {}

export const GlassPanel = forwardRef<HTMLDivElement, GlassPanelProps>((props, ref) => {
	const { className, elevation, ...otherProps } = props;
	return <div className={glassPanelStyles({ className, elevation })} ref={ref} {...otherProps} />;
});
